import { api, apiGet, apiPost, apiTws} from './default'

const cpBase = API_PORTAL;
const mFunds = API_MFUNDS;
const mFundsRest = WR_MFUNDS_API;

function checkCP(response) {
    return apiGet(cpBase + '/sso/validate');
}

function getTotalFunds() {
    return apiGet(mFundsRest + '/grandtotal');
}

function getFundFamilies() {
    return apiGet(mFundsRest + '/families');
}

function logOut() {
    return apiPost(mFunds + '/logout.php');
}

function searchFunds(data) {
    let query = ``;
    if (data.identifier) { query += `&identifier=${ data.identifier }`}
    if (data.family) { query += `&family=${ data.family }`}
    if (data.txnfee) { query += `&txnFee=${ data.txnfee }`}
    if (data.itype) { query += `&iType=${ data.itype }`}
    if (data.page) { query += `&page=${ data.page }` }
    return api.get(`${mFundsRest}/funds?residency=${ data.residency }${ query }`);
}

function getProductRiskLevel(data) {
    const conids = data?.join();
    const endPoint = `fundamentals/data_list?conids=${ conids }&field_names=HSBC_RATING,HSBC_LABEL`;
    return apiTws(endPoint);
}

export default {
    checkCP,
    getTotalFunds,
    getFundFamilies,
    logOut,
    searchFunds,
    getProductRiskLevel
}
